module.exports = __webpack_public_path__ + "static/media/MockPad.063255d9.png";